module.exports = __webpack_public_path__ + "static/img/ColorSicBo.8eb5493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sp/ColorSicBo.png
// module id = QuSi
// module chunks = 1